import React from 'react';
import { X } from 'lucide-react';

const NewAGModal = ({ formData, setFormData, buildings, onSubmit, onClose }) => {
  const getBuildingDisplayName = (building) => {
    if (!building) return '';
    const nom = building.nom || '';
    const adresse = building.adresse || '';
    const codePostal = building.code_postal || '';
    const ville = building.ville || '';
    
    let display = nom;
    if (adresse) {
      display += display ? ` - ${adresse}` : adresse;
    }
    if (codePostal || ville) {
      display += `, ${codePostal} ${ville}`.trim();
    }
    return display || 'Immeuble inconnu';
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-800">Nouvelle Assemblée Générale</h2>
          <button onClick={onClose} data-testid="close-ag-modal">
            <X size={24} className="text-gray-500 hover:text-gray-700" />
          </button>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Immeuble</label>
            <select
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              value={formData.building_id}
              onChange={(e) => setFormData({ ...formData, building_id: e.target.value })}
              required
            >
              <option value="">Sélectionner...</option>
              {buildings?.map(b => (
                <option key={b.id} value={b.id}>{getBuildingDisplayName(b)}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Titre</label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              value={formData.titre}
              onChange={(e) => setFormData({ ...formData, titre: e.target.value })}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              rows={3}
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              required
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
              <input
                type="date"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Heure</label>
              <input
                type="time"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                value={formData.heure}
                onChange={(e) => setFormData({ ...formData, heure: e.target.value })}
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Lieu</label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              value={formData.lieu}
              onChange={(e) => setFormData({ ...formData, lieu: e.target.value })}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Complément</label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              placeholder="Salle Haussmann"
              value={formData.complement_lieu}
              onChange={(e) => setFormData({ ...formData, complement_lieu: e.target.value })}
            />
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3 pt-4">
            <button
              type="submit"
              className="w-full sm:flex-1 bg-[#00D3A8] hover:bg-[#00C7A1] text-white py-2 px-4 rounded-lg transition-colors"
              data-testid="submit-ag-btn"
            >
              Créer
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-full sm:flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewAGModal;
